import { LinearProgress } from "@mui/material"

const ProgressLine = ({ percent }) => {
  const getGradient = () => {
    if (percent < 33) {
      return "linear-gradient(to right, #22c55e, #22c55e, #22c55e, #eab308)"
    } else if (percent > 66) {
      return "linear-gradient(to right, #22c55e, #22c55e, #eab308, #f97316, #ef4444)"
    } else {
      return "linear-gradient(to right, #22c55e, #22c55e, #eab308, #f97316)"
    }
  }

  return (
    <LinearProgress
      variant="determinate"
      value={percent}
      sx={{
        height: 6,
        borderRadius: 6,
        backgroundColor: "#E5EAF2",
        "& .MuiLinearProgress-bar": {
          background: getGradient(),
          borderRadius: 6,
        },
      }}
    />
  )
}

export default ProgressLine
